export const ageMethod = "age nearest";
export const gateway = "https://insurebc-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/insurebc";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJpbnN1cmViYyIsIm5hbWUiOiJpbnN1cmViYyIsImlhdCI6MTc3OTkyMDUyOSwiZXhwIjoxOTM3NzA4NTI5fQ.0CqRxAt3kQ2auaPPsG2ISeBD3SesBVcjDcJTknbYLnU";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"insurebc.link.wawanesalife.com": {
		a: {
			approve_company: "BRITISH COLUMBIA",
			approve_user: "link_insurebc",
			brands: [
				"insurebc.link.wawanesalife.com",
			],
			broker: "insurebc",
			email: "lifeinsurance@insurebc.ca",
			environment: "stable",
			environment_id: "stable",
			ftcLink: "https://www.insurebc.ca/company/terms-and-conditions",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map1": [
					"104-1847 W Broadway",
					"Vancouver",
					"BC",
					"V6J 1Y6",
				],
			},
			menuPhone: "button",
			phone: "1-604-813-2737",
			privacyLink: "https://www.insurebc.ca/company/privacy-policy",
			website: "https://www.insurebc.ca/",
			scope: "insurebc#branding#insurebc.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "insurebc.link.wawanesalife.com",
		},
		b: {
			approve_company: "BRITISH COLUMBIA",
			approve_user: "link_insurebc",
			brands: [
				"insurebc.link.wawanesalife.com",
			],
			broker: "insurebc",
			email: "lifeinsurance@insurebc.ca",
			environment: "stable",
			environment_id: "stable",
			ftcLink: "https://www.insurebc.ca/company/terms-and-conditions",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map1": [
					"104-1847 W Broadway",
					"Vancouver",
					"BC",
					"V6J 1Y6",
				],
			},
			menuPhone: "button",
			phone: "1-604-813-2737",
			privacyLink: "https://www.insurebc.ca/company/privacy-policy",
			website: "https://www.insurebc.ca/",
			scope: "insurebc#branding#insurebc.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "insurebc.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 17:22:09 GMT-0500 (Central Daylight Time)
